import { TAGS_LIST } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case TAGS_LIST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case TAGS_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case TAGS_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
